/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import { useComposerMode } from "cms/components/hooks/use-composer-mode";
import { FieldEditorButtonsDebug } from "cms/fields/layout/footer/field-editor-buttons-debug";
import { HideFieldButton } from "cms/fields/layout/footer/field-hide-button";
import { FieldDefaultsButton } from "cms/fields/layout/footer/field-defaults-button";
import { Logger, redBright } from "cms/utils/log/logger";
import Config from "data/config";

const FieldEditorButtons = () => {
    
    const { contentOnly } = useComposerMode();
    const enableSchemaDefaults = Config.enableSchemaDefaults;
    if (enableSchemaDefaults) {
        Logger.info(redBright("Schema Default code enabled."));
    }
    
    return (
        <Fragment>
            {!contentOnly && (
                <div className={"simplicity-composer-footer-subgroup editor-buttons"}>
                    
                    {enableSchemaDefaults &&
                        <FieldDefaultsButton />
                    }
                    
                    <HideFieldButton />
                    
                    <FieldEditorButtonsDebug />
                    
                </div>
            )}
        </Fragment>
    );
};

export { FieldEditorButtons };

/*
     TODO:
       - `hide` is used to hide the field from display.
       - in the schema (field) `hidden` mandates that we must set .hide = true, and that .hide can not be changed
       -   the toggle should operate on .hide and not operate on .hidden
       -   .hide is saved as part of the field settings in the model
       
     TODO:
       - `style` sets field text styling (many fields are essentially text) for display
       - in the schema (field) `defaultStyle` provides a default value - this can be prepopulated as `style` in the model
       - in the schema (field) `styleOptions` provides the style options to choose from

     TODO:
       - in the schema (field) `defaultValue` provides a default value - this can be prepopulated as the field "value"

     TODO:
       - in the schema (field) `noOverride` mandates that the field "value" must be populated using the defaultValue
          - and that `style` in the model must be populated using the defaultStyle

     TODO:
       - `format` is used to set the format a field
          - meaning to chose and set one of the presentation options.
          - for example: 1) a date format, or 2) show document title vs show document as a link
       - in the schema (field) `formatOptions` provides the format options to choose from
  */
